export default "skymp5-front/d016f173d0d647e6cbe4c46ee74abb05.svg";